import { Fragment, PureComponent, ReactNode } from 'react';
import { TreatmentPlan } from '../../../../../api/getTreatmentPlans';
import { Popover } from 'antd';
import { formattedNumber } from '../../../../../pages/utils';
import PadV2DentalProcedureTable from '../../../leftPanel/DentalChart/DentalProcedure/DentalProcedureTable';
import { DentalProcedureOnPadAutoSuggest } from '../../../leftPanel/DentalChart/DentalProcedure/DentalProcedureAutoSuggest';

interface Props {
    treatmentPlan: TreatmentPlan;
}

class OngoingPlan extends PureComponent<Props> {
    render(): ReactNode {
        const { treatmentPlan } = this.props;
        if (!treatmentPlan) return null;
        const { services } = treatmentPlan;

        return (
            <div className="flex-1 overflow-auto space-y-10 px-1 pb-304">
                {services.map((service) => {
                    const {
                        id,
                        name,
                        teeth_ids,
                        surfaces,
                        qty,
                        mrp,
                        discount,
                        amount,
                        remarks,
                    } = service;
                    const teethAndSurfaces = [
                        teeth_ids?.map((tooth) => `T${tooth}`).join(', '),
                        surfaces?.map((surface) => surface.name).join(', '),
                    ]
                        .filter(Boolean)
                        .join(' | ');

                    return (
                        <div
                            className="rounded-8 space-y-12 px-16 pt-12 pb-16 bg-white"
                            style={{
                                boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.15)',
                            }}
                        >
                            <div className="flex items-center space-x-8">
                                <div
                                    className="w-28 h-28 flex items-center justify-center rounded-4"
                                    style={{ background: '#E8E8E8' }}
                                >
                                    <svg
                                        className="w-16 h-13 fill-darwin-neutral_new-800"
                                        viewBox="0 0 16 13"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path d="M0.6875 3.375C0.6875 2.0293 1.7793 0.9375 3.125 0.9375H12.875C14.2207 0.9375 15.3125 2.0293 15.3125 3.375V9.875C15.3125 11.2207 14.2207 12.3125 12.875 12.3125H3.125C1.7793 12.3125 0.6875 11.2207 0.6875 9.875V3.375ZM5.15625 4.59375V6.01562C5.15625 6.37109 5.41016 6.625 5.76562 6.625H6.98438C7.31445 6.625 7.59375 6.37109 7.59375 6.01562V4.59375C7.59375 3.93359 7.03516 3.375 6.375 3.375C5.68945 3.375 5.15625 3.93359 5.15625 4.59375ZM9.625 3.375C8.93945 3.375 8.40625 3.93359 8.40625 4.59375V6.01562C8.40625 6.37109 8.66016 6.625 9.01562 6.625H10.2344C10.5645 6.625 10.8438 6.37109 10.8438 6.01562V4.59375C10.8438 3.93359 10.2852 3.375 9.625 3.375ZM1.90625 5.40625V6.01562C1.90625 6.37109 2.16016 6.625 2.51562 6.625H3.73438C4.06445 6.625 4.34375 6.37109 4.34375 6.01562V5.40625C4.34375 4.74609 3.78516 4.1875 3.125 4.1875C2.43945 4.1875 1.90625 4.74609 1.90625 5.40625ZM3.125 9.875C3.78516 9.875 4.34375 9.3418 4.34375 8.65625V8.04688C4.34375 7.7168 4.06445 7.4375 3.73438 7.4375H2.51562C2.16016 7.4375 1.90625 7.7168 1.90625 8.04688V8.65625C1.90625 9.3418 2.43945 9.875 3.125 9.875ZM5.15625 8.65625C5.15625 9.3418 5.68945 9.875 6.375 9.875C7.03516 9.875 7.59375 9.3418 7.59375 8.65625V8.04688C7.59375 7.7168 7.31445 7.4375 6.98438 7.4375H5.76562C5.41016 7.4375 5.15625 7.7168 5.15625 8.04688V8.65625ZM9.625 9.875C10.2852 9.875 10.8438 9.3418 10.8438 8.65625V8.04688C10.8438 7.7168 10.5645 7.4375 10.2344 7.4375H9.01562C8.66016 7.4375 8.40625 7.7168 8.40625 8.04688V8.65625C8.40625 9.3418 8.93945 9.875 9.625 9.875ZM11.6562 5.40625V6.01562C11.6562 6.37109 11.9102 6.625 12.2656 6.625H13.4844C13.8145 6.625 14.0938 6.37109 14.0938 6.01562V5.40625C14.0938 4.74609 13.5352 4.1875 12.875 4.1875C12.1895 4.1875 11.6562 4.74609 11.6562 5.40625ZM12.875 9.875C13.5352 9.875 14.0938 9.3418 14.0938 8.65625V8.04688C14.0938 7.7168 13.8145 7.4375 13.4844 7.4375H12.2656C11.9102 7.4375 11.6562 7.7168 11.6562 8.04688V8.65625C11.6562 9.3418 12.1895 9.875 12.875 9.875Z" />
                                    </svg>
                                </div>
                                <p className="text-16 font-700 text-darwin-neutral-1000">{name}</p>
                                {teethAndSurfaces && (
                                    <p className="text-13 text-darwin-neutral_new-800">
                                        ({teethAndSurfaces})
                                    </p>
                                )}
                                <div className="pt-2">
                                    <Popover
                                        placement="right"
                                        title={
                                            <p className="font-700 select-none">Service details</p>
                                        }
                                        content={
                                            <div className="space-y-4 select-none overflow-auto max-h-328 max-w-400">
                                                <div className="flex items-start justify-between">
                                                    <p className="flex-1">Qty</p>
                                                    <p className="text-right w-80">{qty}</p>
                                                </div>
                                                <div className="flex items-start justify-between">
                                                    <p className="flex-1">Mrp</p>
                                                    <p className="text-right w-80">
                                                        ₹{formattedNumber(mrp)}
                                                    </p>
                                                </div>
                                                <div className="flex items-start justify-between">
                                                    <p className="flex-1">Discount</p>
                                                    <p className="text-right w-80">{discount}%</p>
                                                </div>
                                                <div className="flex items-start justify-between">
                                                    <p className="flex-1">Amount</p>
                                                    <p className="text-right w-80">
                                                        ₹{formattedNumber(amount)}
                                                    </p>
                                                </div>
                                            </div>
                                        }
                                        trigger="hover"
                                        overlayClassName="max-w-328"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="w-14 h-14 fill-darwin-neutral_new-800"
                                            viewBox="0 0 14 14"
                                        >
                                            <path d="M7 1.34375C5.0957 1.34375 3.36914 2.35938 2.4043 3.98438C1.46484 5.63477 1.46484 7.64062 2.4043 9.26562C3.36914 10.916 5.0957 11.9062 7 11.9062C8.87891 11.9062 10.6055 10.916 11.5703 9.26562C12.5098 7.64062 12.5098 5.63477 11.5703 3.98438C10.6055 2.35938 8.87891 1.34375 7 1.34375ZM7 13.125C4.66406 13.125 2.53125 11.9062 1.36328 9.875C0.195312 7.86914 0.195312 5.40625 1.36328 3.375C2.53125 1.36914 4.66406 0.125 7 0.125C9.31055 0.125 11.4434 1.36914 12.6113 3.375C13.7793 5.40625 13.7793 7.86914 12.6113 9.875C11.4434 11.9062 9.31055 13.125 7 13.125ZM5.98438 8.65625H6.59375V7.03125H5.98438C5.62891 7.03125 5.375 6.77734 5.375 6.42188C5.375 6.0918 5.62891 5.8125 5.98438 5.8125H7.20312C7.5332 5.8125 7.8125 6.0918 7.8125 6.42188V8.65625H8.01562C8.3457 8.65625 8.625 8.93555 8.625 9.26562C8.625 9.62109 8.3457 9.875 8.01562 9.875H5.98438C5.62891 9.875 5.375 9.62109 5.375 9.26562C5.375 8.93555 5.62891 8.65625 5.98438 8.65625ZM7 5C6.54297 5 6.1875 4.64453 6.1875 4.1875C6.1875 3.75586 6.54297 3.375 7 3.375C7.43164 3.375 7.8125 3.75586 7.8125 4.1875C7.8125 4.64453 7.43164 5 7 5Z" />
                                        </svg>
                                    </Popover>
                                </div>
                            </div>
                            {remarks && (
                                <p className="text-13 text-darwin-neutral_new-800">
                                    Remarks: {remarks}
                                </p>
                            )}
                            <Fragment>
                                <PadV2DentalProcedureTable service_id={id} />
                                <DentalProcedureOnPadAutoSuggest service_id={id} />
                            </Fragment>
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default OngoingPlan;
